/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PremiumDueInsuredOptionDto } from './PremiumDueInsuredOptionDto';
import {
    PremiumDueInsuredOptionDtoFromJSON,
    PremiumDueInsuredOptionDtoFromJSONTyped,
    PremiumDueInsuredOptionDtoToJSON,
    PremiumDueInsuredOptionDtoToJSONTyped,
} from './PremiumDueInsuredOptionDto';
import type { PremiumDueBinderOptionDto } from './PremiumDueBinderOptionDto';
import {
    PremiumDueBinderOptionDtoFromJSON,
    PremiumDueBinderOptionDtoFromJSONTyped,
    PremiumDueBinderOptionDtoToJSON,
    PremiumDueBinderOptionDtoToJSONTyped,
} from './PremiumDueBinderOptionDto';
import type { PremiumDueBrokerOptionDto } from './PremiumDueBrokerOptionDto';
import {
    PremiumDueBrokerOptionDtoFromJSON,
    PremiumDueBrokerOptionDtoFromJSONTyped,
    PremiumDueBrokerOptionDtoToJSON,
    PremiumDueBrokerOptionDtoToJSONTyped,
} from './PremiumDueBrokerOptionDto';
import type { PremiumDueReinsuredOptionDto } from './PremiumDueReinsuredOptionDto';
import {
    PremiumDueReinsuredOptionDtoFromJSON,
    PremiumDueReinsuredOptionDtoFromJSONTyped,
    PremiumDueReinsuredOptionDtoToJSON,
    PremiumDueReinsuredOptionDtoToJSONTyped,
} from './PremiumDueReinsuredOptionDto';

/**
 * 
 * @export
 * @interface PremiumDueOptionsResponseDto
 */
export interface PremiumDueOptionsResponseDto {
    /**
     * 
     * @type {Array<PremiumDueBrokerOptionDto>}
     * @memberof PremiumDueOptionsResponseDto
     */
    brokers: Array<PremiumDueBrokerOptionDto>;
    /**
     * 
     * @type {Array<PremiumDueReinsuredOptionDto>}
     * @memberof PremiumDueOptionsResponseDto
     */
    reinsured: Array<PremiumDueReinsuredOptionDto>;
    /**
     * 
     * @type {Array<PremiumDueInsuredOptionDto>}
     * @memberof PremiumDueOptionsResponseDto
     */
    insured: Array<PremiumDueInsuredOptionDto>;
    /**
     * 
     * @type {Array<PremiumDueBinderOptionDto>}
     * @memberof PremiumDueOptionsResponseDto
     */
    binder: Array<PremiumDueBinderOptionDto>;
}

/**
 * Check if a given object implements the PremiumDueOptionsResponseDto interface.
 */
export function instanceOfPremiumDueOptionsResponseDto(value: object): value is PremiumDueOptionsResponseDto {
    if (!('brokers' in value) || value['brokers'] === undefined) return false;
    if (!('reinsured' in value) || value['reinsured'] === undefined) return false;
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('binder' in value) || value['binder'] === undefined) return false;
    return true;
}

export function PremiumDueOptionsResponseDtoFromJSON(json: any): PremiumDueOptionsResponseDto {
    return PremiumDueOptionsResponseDtoFromJSONTyped(json, false);
}

export function PremiumDueOptionsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumDueOptionsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'brokers': ((json['brokers'] as Array<any>).map(PremiumDueBrokerOptionDtoFromJSON)),
        'reinsured': ((json['reinsured'] as Array<any>).map(PremiumDueReinsuredOptionDtoFromJSON)),
        'insured': ((json['insured'] as Array<any>).map(PremiumDueInsuredOptionDtoFromJSON)),
        'binder': ((json['binder'] as Array<any>).map(PremiumDueBinderOptionDtoFromJSON)),
    };
}

export function PremiumDueOptionsResponseDtoToJSON(json: any): PremiumDueOptionsResponseDto {
    return PremiumDueOptionsResponseDtoToJSONTyped(json, false);
}

export function PremiumDueOptionsResponseDtoToJSONTyped(value?: PremiumDueOptionsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brokers': ((value['brokers'] as Array<any>).map(PremiumDueBrokerOptionDtoToJSON)),
        'reinsured': ((value['reinsured'] as Array<any>).map(PremiumDueReinsuredOptionDtoToJSON)),
        'insured': ((value['insured'] as Array<any>).map(PremiumDueInsuredOptionDtoToJSON)),
        'binder': ((value['binder'] as Array<any>).map(PremiumDueBinderOptionDtoToJSON)),
    };
}

